module.exports = __webpack_public_path__ + "static/media/news-img3.5deae47f.png";